import React, { Component } from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import _map from "lodash/map";
import _includes from "lodash/includes";
import { Modal, FloatLabelSelect } from "shared/components";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";

import LowQualityForm from "./LowQualityForm";
import UnavailableForm from "./UnavailableForm";
import CallingProblemForm from "./CallingProblemForm";

const REASONS = {
  VOICE_CIRCUIT_UNAVAILABLE: "Circuito de Voz indisponível",
  CALL_ORIGINATION_FAILED: "Falha ao originar chamadas",
  FAILED_TO_RECEIVE_CALLS: "Falha ao receber chamadas",
  MUTE_CALLS: "Ligações Mudas",
  CALL_DROPS: "Queda de Ligação",
  LOW_QUALITY: "Reclamação baixa qualidade (eco, picotes e ruídos)",
  ALREADY_NORMALIZED: "Causa de Queda já normalizada",
};
class ModalTotalVoice extends Component {
  state = {
    reason: REASONS.VOICE_CIRCUIT_UNAVAILABLE,
  };

  getOptions() {
    return _map(REASONS, (reason) => {
      return {
        value: reason,
        label: reason,
      };
    });
  }

  onChangeReason = (e) => {
    const { value } = e.target;
    this.setState({ reason: value });
  };

  render() {
    const {
      t,
      isCurrentStep,
      onNextStep,
      onPreviousStep,
      onReset,
    } = this.props;
    const { reason } = this.state;

    return (
      <Modal
        isOpen={isCurrentStep}
        onClose={onReset}
        title={t("MSG_0194")}
        icon={IconRepair}
        ariaHideApp={false}
      >
        <FloatLabelSelect
          label={t("MSG_0216")}
          name="reason"
          value={this.state.reason}
          options={this.getOptions()}
          onChange={this.onChangeReason}
          defaultOption
        />

        {_includes([REASONS.VOICE_CIRCUIT_UNAVAILABLE], reason) && (
          <UnavailableForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.reason}
          />
        )}

        {_includes(
          [
            REASONS.CALL_ORIGINATION_FAILED,
            REASONS.FAILED_TO_RECEIVE_CALLS,
            REASONS.MUTE_CALLS,
            REASONS.CALL_DROPS,
          ],
          reason
        ) && (
          <CallingProblemForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.reason}
          />
        )}

        {_includes([REASONS.LOW_QUALITY], reason) && (
          <LowQualityForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.reason}
          />
        )}

        {_includes([REASONS.ALREADY_NORMALIZED], reason) && (
          <CallingProblemForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={this.state.reason}
            hasFailureDate={true}
          />
        )}
      </Modal>
    );
  }
}

const enhance = compose(translate());

export default enhance(ModalTotalVoice);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalTotalVoice/index.js